import { Grilla, GrillaEl, PilaV, Texto } from '@/components/atomos';
import { Card, CardBody, Heading, Icon, useMediaQuery } from '@chakra-ui/react';
import {
  CalendarClock,
  HandCoins,
  Handshake,
  LucideIcon,
  Users,
} from 'lucide-react';
import { FC } from 'react';

type BeneficioProps = {
  icono: LucideIcon;
  titulo: string;
  informacion: string;
};

const Beneficio: FC<BeneficioProps> = ({ icono, informacion, titulo }) => {
  return (
    <GrillaEl colSpan={1} as={Card} size={'md'}>
      <CardBody as={PilaV} textAlign={'center'}>
        <Icon as={icono} boxSize='16' color='bGreen.600' />
        <Texto fontWeight={'medium'}>{titulo}</Texto>
        <Texto color={'foreground-secondary'}>{informacion}</Texto>
      </CardBody>
    </GrillaEl>
  );
};

const Beneficios = () => {
  const [mobile] = useMediaQuery('(max-width: 768px)');
  return (
    <PilaV w={'full'} spacing={10}>
      <PilaV w={'full'} spacing={0}>
        <Heading>
          Ventajas que marcan la{' '}
          <Texto as={'span'} color={'bGreen.600'}>
            diferencia
          </Texto>
        </Heading>
        <Texto color={'foreground-secondary'}>
          Descubre cómo nuestros servicios pueden simplificar y mejorar tu vida
          económica
        </Texto>
      </PilaV>
      <Grilla templateColumns={mobile ? '1fr' : 'repeat(4, 1fr)'} gap={8}>
        <Beneficio
          icono={HandCoins}
          titulo='Liquidez asegurada'
          informacion='Nuestras operaciones cuentan con el apoyo de la Financiera Progreso con mas de 10 años de experiencia en el rubro'
        />
        <Beneficio
          icono={Handshake}
          titulo='Tasas competitivas'
          informacion='Accede a tasas competitivas y transparentes para financiar tus facturas al mejor costo.'
        />
        <Beneficio
          icono={Users}
          titulo='Asesoramiento 1 a 1'
          informacion='Nuestros especialistas estarán a tu lado para acompañarte en cada parte del proceso.'
        />
        <Beneficio
          icono={CalendarClock}
          titulo='Eficaz y 100% digital'
          informacion='¡Cuida tu tiempo! Olvídate de la burocracia y papeleos innecesarios. Recibe tu financiamiento en minutos.'
        />
      </Grilla>
    </PilaV>
  );
};

export default Beneficios;
